/**
 * 标准界面-处理ag表格列数据
 * 标准界面定制tab，表格列显示不一样
 */
const columnsList = {
  // 异常预警
  OC_B_RETURN_ORDER_WARNING: {
    1: [
      'ID',
      'TID', // 平台单号
      'CP_C_SHOP_ID', // 下单店铺
      'USER_NICK', // 买家昵称
      'PS_C_PRO_SKU', // 商品SKU
      'TOT_SNED_QTY', // 发货数量
      'TOT_REFUND_QTY', // 退款数量
      'SG_B_OUT_BILL_ID', // 出库通知单
      'CP_C_PHY_WAREHOUSE_ID', // 发货实体仓
      'CP_C_LOGISTICS_ID', // 物流公司
      'EXPRESSCODE', // 物流编码
      'AMT_RETURN', // 退款金额
      'RETURNDATE', // 退款时间
      'MANAGE_RESULT', // 处理结果
      'ORDER_AMT', // 订单总金额
      'PAY_TIME', // 付款时间
      'WAREHOUSE_DELIVERY_TIME', // 仓库发货时间
      'CREATIONDATE' // 创建时间
    ],
    2: [
      'ID',
      'TID', // 平台单号
      'CP_C_SHOP_ID', // 下单店铺
      'USER_NICK', // 买家昵称
      'PS_C_PRO_SKU', // 商品SKU
      'TOT_REFUND_QTY', // 退款数量
      'ORDER_RETURN_BILL_NO', // 退换货单据编号
      'CP_C_PHY_WAREHOUSE_IN_ID', // 入库实体仓库
      'CP_C_LOGISTICS_RETURN_ID', // 退回物流公司
      'LOGISTICS_CODE', // 退回物流单号
      'AMT_RETURN', // 退款金额
      'RETURNDATE', // 退款时间
      'ORDER_AMT', // 订单总金额
      'PAY_TIME', // 付款时间
      'WAREHOUSE_DELIVERY_TIME', // 仓库发货时间
      'CREATIONDATE' // 创建时间
    ],
    3: [
      'ID',
      'TID', // 平台单号
      'CP_C_SHOP_ID', // 下单店铺
      'USER_NICK', // 买家昵称
      'PS_C_PRO_SKU', // 商品SKU
      'TOT_SNED_QTY', // 发货数量
      'TOT_REFUND_QTY', // 退款数量
      'SG_B_OUT_BILL_ID', // 出库通知单
      'CP_C_PHY_WAREHOUSE_ID', // 发货实体仓
      'CP_C_LOGISTICS_ID', // 物流公司
      'EXPRESSCODE', // 物流编码
      'AMT_RETURN', // 退款金额
      'RETURNDATE', // 退款时间
      'MANAGE_RESULT', // 处理结果
      'ORDER_AMT', // 订单总金额
      'PAY_TIME', // 付款时间
      'WAREHOUSE_DELIVERY_TIME', // 仓库发货时间
      'CREATIONDATE' // 创建时间
    ],
    '4': [
      'ID',
      'TID',  // 平台单号
      'CP_C_SHOP_ID', // 下单店铺
      'SG_B_OUT_BILL_ID', // 出库通知单
      'PS_C_PRO_SKU', // 商品SKU
      'USER_NICK', // 买家昵称
      'CP_C_PHY_WAREHOUSE_ID', // 发货实体仓
      'CP_C_LOGISTICS_ID', // 物流公司
      'EXPRESSCODE', // 物流编码
      'AMT_RETURN', // 退款金额
      'RETURNDATE', // 退款时间
      'MANAGE_RESULT', // 处理结果
    ]

  }
}
export default columnsList
